import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { SearchRecursive, SelectRecursive, stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import  { ProductGroupSelectorView } from "./productGroupSelector-view"

export class ProductGroupSelectorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.groups = ObservableArray.create<productGroup>();
        this.refresh();
 
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductGroupSelectorView();
    }
    public getTypeId(): string {
        return "VM-D7F37635-AAEB-4B5D-AD8A-0E43CB1119E4"
    }

    public set groups(v: ObservableArray<productGroup>) { this._groups = v; } public get groups(): ObservableArray<productGroup> { return this._groups;} private _groups: ObservableArray<productGroup>;
    public set selectedGroup(v: productGroup) { this._selectedGroup = v; } public get selectedGroup(): productGroup { return this._selectedGroup;} private _selectedGroup: productGroup;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedGroupName(v: string) { this._selectedGroupName = v; } public get selectedGroupName(): string { return this._selectedGroupName;} private _selectedGroupName: string;
    public set selectedGroupCode(v: string) { this._selectedGroupCode = v; } public get selectedGroupCode(): string { return this._selectedGroupCode;} private _selectedGroupCode: string;
    
    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductGroupManagement/GetAllProductGroups',{});
            let groups = SelectRecursive<any,productGroup>(this,result.Groups,x=>x.Children,(x,parent)=>{
                let result :productGroup = new productGroup(parent);
                result.id = x.Id;
                result.name = x.Name;
                result.prefix = x.PrefixCode;
                return result;
            },(x,y)=>x.children.update(...y));
            groups.forEach(q=>q.updatePrefixPath(''));
            groups.forEach(q=>q.updateAllowSelection());
            this.groups.update(...groups);
            this.selectById(this.selectedId);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    private selectedId:string;
    selectById(id:string){
        if(stringIsNullOrEmpty(id)){
            return;
        }
        this.selectedId = id;
        if(this.groups.length>0){
            let group = SearchRecursive(this.groups,x=>x.children,x=>x.id==this.selectedId);
            this.selectedGroup = group;
            this.updateSelectedGroupInfo();
        }
    }
    
    public handleMessage(message: ViewModelMessage) {
        if(message instanceof selectProductGroupMessage){
            this.selectedId = message.productGroup.id;
            this.selectedGroup = message.productGroup;
            this.updateSelectedGroupInfo();
        }else{
            return super.handleMessage(message);
        }
    }

    updateSelectedGroupInfo(){
        if(this.selectedGroup!=null){
            this.selectedGroupName = this.selectedGroup.name;
            this.selectedGroupCode = this.selectedGroup.prefixPath;
        }else{
            this.selectedGroupName = '';
            this.selectedGroupCode = '';

        }
    }
}
export class productGroup extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);

        this.children = ObservableArray.create<productGroup>();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set prefix(v: string) { this._prefix = v; } public get prefix(): string { return this._prefix;} private _prefix: string;
    public set prefixPath(v: string) { this._prefixPath = v; } public get prefixPath(): string { return this._prefixPath;} private _prefixPath: string;
    public set children(v: ObservableArray<productGroup>) { this._children = v; } public get children(): ObservableArray<productGroup> { return this._children;} private _children: ObservableArray<productGroup>;
    public set allowSelection(v: boolean) { this._allowSelection = v; } public get allowSelection(): boolean { return this._allowSelection;} private _allowSelection: boolean;
    
    select(){
        if(this.children.length==0){
            this.handleMessage(new selectProductGroupMessage(this));
        }
    }

    updateAllowSelection(): void {
        if(this.children.length==0){
            this.allowSelection = true;
        }else{
            this.allowSelection = false;
        }
    }
    updatePrefixPath(parentPrefix:string): void {
        let prefixPath = `${parentPrefix}${this.prefix}`;
        this.prefixPath = prefixPath;
        this.children.forEach(x=>x.updatePrefixPath(prefixPath));
    }
    
}

class selectProductGroupMessage extends ViewModelMessage{
    constructor(productGroup:productGroup) {
        super();
        this.productGroup = productGroup;
    }
    public productGroup : productGroup;
}